export default "__VITE_ASSET__082upnMY__"